import { render, staticRenderFns } from "./notice-content.vue?vue&type=template&id=fda2a290&"
import script from "./notice-content.vue?vue&type=script&lang=js&"
export * from "./notice-content.vue?vue&type=script&lang=js&"
import style0 from "./notice-content.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports